
import { createStore } from 'redux'
const reducer = (state = [], action) => {
  if (action.type === 'add_to_array') {
      return [action.payload]
  } else if (action.type === 'add_planes') {
      return [action.planes]
    }
  return state
}
export default createStore(reducer)


// WEBPACK FOOTER //
// ./src/components/Commons/store.js